import * as preact from 'preact'
const { h, Component } = preact
import PureComponent from '../../../lib/preact-pure-component'
import styles from './style.css'
import { Paragraph } from '@nrk/dh-feature-components'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

interface Props {
  isOpen: boolean
  close: () => void
  content?: any
  idx?: number
}

interface State {
  prevFocus: any
}

export class Modal extends PureComponent<Props, State> {
  content?: HTMLDivElement
  modal?: HTMLDivElement

  componentDidMount() {
    document.addEventListener('keydown', this.handleEscClick, false)
  }

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.open()
    } else if (prevProps.isOpen && !this.props.isOpen) {
      this.close()
    }
  }

  componentWillUnmount() {
    clearAllBodyScrollLocks()
    this.close()
    document.removeEventListener('keydown', this.handleEscClick, false)
  }

  handleEscClick = (event: any) => {
    if (event.keyCode === 27) {
      this.props.close()
    }
  }

  open = () => {
    this.setState({ prevFocus: document.activeElement })
    disableBodyScroll(this.modal)
  }

  close = () => {
    clearAllBodyScrollLocks()
    if (this.state.prevFocus) {
      this.state.prevFocus.focus()
    }
  }

  closeOnClickOutside = (event: any) => {
    if (this.content && !this.content.contains(event.target)) {
      this.props.close()
    }
  }

  getIdMarkup = (id: string) => {
    const regex = /(_)/gi
    return id.replace(regex, '<span>$1</span>')
  }

  render() {
    const { content, isOpen, idx } = this.props
    if (!isOpen) {
      return null
    }
    return (
      <div className={styles.wrapper}>
        <div
          className={styles.modal}
          role="dialog"
          onClick={this.closeOnClickOutside}
          ref={modal => (this.modal = modal)}
        >
          <div className={styles.content} ref={content => (this.content = content)}>
            <button className={styles.closeCircle} onClick={this.props.close}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
                <path stroke="currentColor" d="M5 5l5 5m-5 0l5-5" stroke-linecap="round" />
                <circle fill="none" stroke="currentColor" cx="7.5" cy="7.5" r="6.5" stroke-linecap="square" />
              </svg>
            </button>
            {idx !== undefined && (
              <div className={styles.id}>
                Fotnote<span>_</span>
                {idx + 1}
              </div>
            )}
            <Paragraph html={content.text} className={styles.text} />
            <button onClick={this.props.close} className={styles.button + ' nrk-button'}>
              Lukk
            </button>
          </div>
        </div>
      </div>
    )
  }
}
